import { render, staticRenderFns } from "./InvPD_Details.vue?vue&type=template&id=4d188577"
import script from "./InvPD_Details.vue?vue&type=script&lang=js"
export * from "./InvPD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports